import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';

import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';

/* core, added isScrollTop(line 9, 16) */
export const useNavigateToPrevPage = ({ isScrollTop = false } = {}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const rootPage = useAppSelector(prop('rootPage'));
    const { prevPath } = location.state || {};

    return useCallback(() => {
        navigate(prevPath || rootPage, {}, { isScrollTop });
    }, [prevPath, rootPage, navigate, isScrollTop]);
};
